'use client';

import { createElement as g } from "react";
import { Provider as S } from "effector-react";
import { fork as a } from "effector";
const l = typeof document < "u", C = l ? j : _;
function _(e) {
  return a({ values: e });
}
function x() {
  return l ? o : null;
}
const o = a();
let s;
function j(e) {
  return !e || /**
  * This is a hack to handle edge cases with shallow navigation
  *
  * In this case Next.js will basically re-use old pageProps,
  * but we already have latest state in the client scope
  *
  * So this update is just skipped
  */
  e === s || (s = e, A(o, e), E(o, e)), o;
}
function A(e, n) {
  Object.assign(e.values.sidMap, n);
}
function E(e, n) {
  var i, u, d, m;
  for (const f in e.reg)
    if (Object.hasOwnProperty.call(e.reg, f)) {
      const t = e.reg[f];
      if (!t.meta || !((i = t.meta) != null && i.named) && ((u = t.meta) != null && u.derived))
        delete e.reg[f];
      else {
        const c = (d = t == null ? void 0 : t.meta) == null ? void 0 : d.sid;
        if (c && c in n) {
          const r = (m = t == null ? void 0 : t.meta) == null ? void 0 : m.serialize, p = r && r !== "ignore" ? r == null ? void 0 : r.read : null;
          t.current = p ? p(n[c]) : n[c];
        }
      }
    }
}
function y({
  values: e,
  children: n
}) {
  const i = C(e);
  return g(S, { value: i }, n);
}
export {
  y as EffectorNext,
  x as getClientScope
};
